<template>
  <d-container fluid class="main-content-container px-4 pb-4">
      <div class="container">
        <img class="ignite-logo" src="/prayer.admin/img/odp.png">
        <div class="manage-account">
        <div class="" style="text-align:center">
          <d-row>
            <d-col md="12" class="form-group">
                <input class="rfid-box" id="rfid" name="rfid" v-model="rfid" autofocus type="text"  @keyup.enter="rsubmit" placeholder="Scan RFID" />
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t1 class="ignite-result-1" v-if="first_time">
              Selamat bergabung di One Day Prayer
            </div>
            <div id=ts1 class="ignite-result-1" v-if="signout">
              {{statement_1}}
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t2 class="ignite-result-2">
              {{data_str}}
            </div>
            <div id=t4 class="ignite-result-3" >
                <span v-if="already_scanned">Anda sudah terdaftar</span>
            </div>
            <div id=tc class="ignite-result-3">
              ( Circle {{circle_str}} )
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12">
            <div id=t3 class="ignite-result-1" style="font-size:3em" v-if="first_time">
Silahkan hadir Selasa 25 Agustus 2026
pk 07.00<br>
<span style="font-size:.7em;line-height:normal">membawa hidangan ringan ( porsi sendiri ) utk sarapan pagi bersama</span>
            </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col md="12" class="form-group">
            <div style="min-height:30px;margin-top:5px;color:red;font-size:.8rem;">
              {{error_str}}
            </div>
            </d-col>
          </d-row>
        </div>
        </div>
      </div>
      <div style="position:absolute;bottom:0px;font-size:3em;color:orange;text-align:center;width:100%;margin-left:-1.5rem;background-color:blue;">
REGISTRASI ONE DAY PRAYER, SELASA 25 AGUSTUS 2026
      </div>
  </d-container>
</template>
<style>
#rfid:focus{
outline:none;
}
.ignite-s2-last{
font-size:4em;
color:#1589FF;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-1{
font-size:4em;
color:orange;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-2{
font-size:6em;
color:#c70;
text-transform: uppercase;
transition: opacity 2s ease;
opacity:0;
}
.ignite-result-3{
font-size:3em;
color:#c70;
text-transform: uppercase;
transition: opacity 2s ease;
opacity:0;
}
@keyframes fadeOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}
.fade-out {
    animation: fadeOut 10s forwards;
}
.rfid-box {
    font-size: 12px;
    background: blue !important;
    color: yellow;
    border: none !important;
    border-radius:0 !important;
    transition: all .3s ease-in-out;
    width:100%;
    position:fixed;
    top:0;
    left:0;
}

@keyframes logoAnimation {
    0% { filter: brightness(1); }
    100% { filter: brightness(2); }
}    

.ignite-logo {
    margin-top:.5em;
    width: 30vh;
    height: auto;
    animation: logoAnimation 1s ease infinite alternate;
}
</style>
<script>
import axios from 'axios';
import env from '../env.vue';

export default {
  data(){
    return{
      statement_1:'',
      rfid:'',
      error_str:'',
      data_str:'',
      circle_str:'',
      loading:false,
      id1:0,
      id2:0,
      id3:0,
      first_time:false,
      signout:false,
      already_scanned:false,
      s2_last_episode:false,  
    }
  },
  
  methods: {
	playAudio(filePath) {
	  const audio = new Audio(filePath);
      audio.playbackRate = 1;
	  audio.play();
	},
    rsubmit(e){
      e.preventDefault()
      this.error_str=''
      this.data_str=''
      this.circle_str=''
      this.loading=true
      axios.get(env.server+'/registration/save/'+this.rfid, 
      {
      }
      ).then(resp => {
        this.loading=false;
        if (this.id1>0) { clearTimeout(this.id1); this.id1=0 }
        if (this.id2>0) { clearTimeout(this.id2); this.id2=0 }
        if (this.id3>0) { clearTimeout(this.id3); this.id3=0 }
        console.log('resp',resp.data);
        let adata = resp.data.data[0];
        this.data_str=adata.fullname;
        this.circle_str=adata.circle>0 ? adata.circle: 'belum ada';
        this.rfid='';
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const month = String(currentDate.getMonth() + 1).padStart(2, "0"); 
		const day = String(currentDate.getDate()).padStart(2, "0"); 
        const ddate=year+'-'+month+'-'+day;  
        this.first_time = adata.data!='' && ddate==adata.data  
        console.log('first_time', this.first_time, adata.data, ddate) 
        document.getElementById('t2').style.opacity='1';
        document.getElementById('t4').style.opacity='0';
        if (this.first_time){
            document.getElementById('t4').style.display='none';

			document.getElementById('tc').style.opacity='1';
			document.getElementById('tc').style.display='block';
            this.playAudio('/prayer.admin/mp3/selamat_bergabung'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
			  setTimeout( ()=>{
			  document.getElementById('t1').style.opacity='1';
			  document.getElementById('t3').style.opacity='1';
			  },100)
			  this.id1=setTimeout( ()=>{
			  document.getElementById('t1').style.opacity='0';
			  document.getElementById('t3').style.opacity='0';
			  },90000)
        } else {
          this.already_scanned=true  
          console.log('already_scanned', this.already_scanned)
          document.getElementById('t4').style.opacity='1';
          document.getElementById('t4').style.display='block';
          document.getElementById('tc').style.opacity='1';
          document.getElementById('tc').style.display='block';
        } 
        this.id2=setTimeout( ()=>{
        document.getElementById('t2').style.opacity='0';
        document.getElementById('tc').style.opacity='0';
        document.getElementById('t4').style.opacity='0';
        },90000)
      }).catch( error => {
        this.loading=false;
        this.rfid='';
        if(error.response==undefined)return;
        console.log('err',error.response);
        if ( error.response.status=='404' ){
          this.playAudio('/prayer.admin/mp3/notfound'+(Math.floor(Math.random() * 4) + 1)+'.mp3');
          this.error_str='Invalid RFID';
          this.already_scanned=false;
          this.first_time=false;
        }
      });
    }
  },
  mounted(){
   document.getElementsByTagName('html')[0].style.overflow='hidden';
  }
};
</script>
